module.exports = __webpack_public_path__ + "static/media/ENGProjectPrevieww1870@2x.e71e6269.webp";